// @flow

import { type OutgoingPayment } from '@tectonics/prs/outgoing-payment';
import { type UserInputValues } from '@tectonics/prs/user-input-values';

export async function virtualAccountOutgoingPaymentMapper(userInputValues: UserInputValues): Promise<$Shape<OutgoingPayment>> {
  return {
    payment_type: 'banktransfer',
    payment_type_code: 'virtual-account',
    bank_details: {
      bank_code: userInputValues['selectedVirtualAccountBank'],
      account_number: '',
    },
  };
}
